import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Icon,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";

export const WithdrawNeedButton = ({
  onWithdraw,
  isDisabled = false,
}: {
  onWithdraw: () => Promise<void> | void;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  const confirm = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [isWithdrawing, setIsWithdrawing] = useState(false);

  const onConfirm = async () => {
    if (isWithdrawing) return;
    setIsWithdrawing(true);
    try {
      await onWithdraw();
    } finally {
      setIsWithdrawing(false);
      confirm.onClose();
    }
  };

  return (
    <>
      <Button
        colorScheme="red"
        variant="outline"
        leftIcon={<Icon as={FiArrowRight} />}
        onClick={confirm.onOpen}
        isDisabled={isDisabled}
      >
        {t("Withdraw need")}
      </Button>
      <AlertDialog isOpen={confirm.isOpen} leastDestructiveRef={cancelRef} onClose={confirm.onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>{t("Withdraw this need?")}</AlertDialogHeader>
            <AlertDialogBody>{t("This is final and cannot be undone.")}</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={confirm.onClose} variant="ghost" isDisabled={isWithdrawing}>
                {t("Cancel")}
              </Button>
              <Button colorScheme="red" onClick={onConfirm} ml="3" isLoading={isWithdrawing}>
                {t("Withdraw")}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
